let translations = {};

export function setTranslations(newTranslations) {
  translations = newTranslations;
}

export function getTranslation(name) {
  return translations[name];
}